import { currencyFormatter } from 'utils'

export const LevelTableRow = ({ level, id, achievementUser }) => {
  return (
    <div className={`table_row ${level.level === achievementUser.level ? 'current' : ''}`}>
      <label className='tier_level'>{id}</label>
      <label className='tier'>
        {level.name}
        <div
          className='badge_icon'
          style={{
            backgroundImage: `url(${level.icon}) `,
          }}
        ></div>
      </label>
      <label>{currencyFormatter(level.xp_requirement, { noCurrencySign: true, decimalDigits: 0 })}</label>
      <label>{currencyFormatter(level.reward)}</label>
    </div>
  )
}
